import { Onboarding } from './onboarding';

export { Onboarding };
